import { render, staticRenderFns } from "./activityFlowApproval.vue?vue&type=template&id=9b62136c&scoped=true&"
import script from "./activityFlowApproval.vue?vue&type=script&lang=js&"
export * from "./activityFlowApproval.vue?vue&type=script&lang=js&"
import style0 from "./activityFlowApproval.vue?vue&type=style&index=0&id=9b62136c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b62136c",
  null
  
)

export default component.exports